import React, { useState, useEffect } from 'react'
import Switch from "react-switch";
import { toast } from "react-toastify";
import { useUpdateOpenForumRSVPAttendance } from '../../../../hooks/apis/useOpenForum.api';




export default function MarkAttendance({
  data
}) {

  const [inAttendance,] = useState(data?.attendance)

  const {
    status,
    mutate,
    error
  } = useUpdateOpenForumRSVPAttendance(data?.id, {
    "attendance": (inAttendance === "Yes") ? "No" : "Yes"
  });

  useEffect(() => {
    if (status === "success") {
      toast.success(`${data?.name} attendance updated`)
    }
  }, [data?.name, status])

  status === "error" && toast.error(error?.response?.data?.error);



  const handleChange = () => {
    mutate(); //? call mutate function
  }




  return (
    <>
      <Switch
        onChange={handleChange}
        checked={inAttendance === "Yes" ? true : false}
        className="react-switch"
        handleDiameter={24}
        uncheckedIcon={false}
        checkedIcon={false}
        boxShadow="0"
        activeBoxShadow="0"
        height={28}
        width={46}
        id="material-switch"
        offColor="#B9B9B9"
        onColor="#89B369"
        offHandleColor="#ffffff"
        onHandleColor="#ffffff"
      />
    </>
  )
}


